// ════════════════════════════════════════════════════════════════════
// src/components/AvisoConvite.js — "Fulano te convidou. Aceita?"
// ════════════════════════════════════════════════════════════════════
// Por que perguntar em vez de entrar direto: criar convite é uma escrita
// que qualquer conta logada pode fazer para qualquer e-mail. Se o aceite
// fosse automático, bastava alguém criar um convite com o seu e-mail para
// você começar a digitar os dados dos seus clientes dentro da conta dele
// sem perceber. Com a pergunta, isso vira uma escolha consciente.
// ════════════════════════════════════════════════════════════════════

import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { labelPapel, corPapel, PAPEIS } from '../permissoes';

export default function AvisoConvite() {
  const { convitePendente, aceitarConvite, recusarConvite } = useAuth();
  const [ocupado, setOcupado] = useState('');
  const [erro, setErro] = useState('');

  if (!convitePendente) return null;

  const c = convitePendente;
  const cor = corPapel(c.papel);
  const areas = (PAPEIS[c.papel]?.areas || []).filter(a => a !== 'home');

  const acao = async (qual) => {
    setOcupado(qual); setErro('');
    try {
      if (qual === 'aceitar') await aceitarConvite();
      else await recusarConvite();
    } catch (e) {
      setErro('Não deu certo: ' + (e?.message || e));
      setOcupado('');
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 400,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '30px', width: '480px',
        maxWidth: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>

        <div style={{ fontSize: '32px', marginBottom: '12px' }}>✉️</div>
        <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '19px', marginBottom: '10px' }}>
          Você foi convidado para uma conta
        </h2>
        <p style={{ fontSize: '13.5px', color: '#52526e', lineHeight: 1.65, marginBottom: '16px' }}>
          <strong>{c.donoEmail || 'O administrador'}</strong> convidou você para trabalhar na conta dele
          como <strong style={{ color: cor }}>{labelPapel(c.papel)}</strong>.
        </p>

        <div style={{ background: '#f8f8fc', border: '1px solid rgba(0,0,0,0.07)', borderRadius: '10px',
          padding: '14px 16px', marginBottom: '16px' }}>
          <div style={{ fontSize: '10px', fontWeight: '700', color: '#52526e', fontFamily: 'monospace',
            textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '8px' }}>
            O que você vai poder usar
          </div>
          <div style={{ fontSize: '12.5px', color: '#52526e', lineHeight: 1.7 }}>
            {PAPEIS[c.papel]?.desc}
          </div>
          <div style={{ fontSize: '11px', color: '#9898b8', marginTop: '8px', fontFamily: 'monospace' }}>
            {areas.length} área{areas.length === 1 ? '' : 's'} liberada{areas.length === 1 ? '' : 's'}
          </div>
        </div>

        <div style={{ background: 'rgba(245,158,11,0.07)', border: '1px solid rgba(245,158,11,0.25)',
          borderRadius: '10px', padding: '12px 14px', marginBottom: '18px',
          fontSize: '12.5px', color: '#92400e', lineHeight: 1.6 }}>
          Ao aceitar, você passa a trabalhar <b>dentro da conta dele</b> — os clientes, leads e disparos
          que você vir e criar são da conta dele, não sua. Se não conhece quem convidou, recuse.
        </div>

        {erro && (
          <div style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)',
            borderRadius: '9px', padding: '10px 14px', marginBottom: '14px', fontSize: '12.5px', color: '#dc2626' }}>
            ⚠ {erro}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button onClick={() => acao('recusar')} disabled={!!ocupado}
            style={{ border: '1.5px solid rgba(0,0,0,0.1)', background: 'none', borderRadius: '10px',
              padding: '10px 18px', fontSize: '14px', cursor: ocupado ? 'wait' : 'pointer',
              color: '#52526e', fontFamily: 'DM Sans, sans-serif' }}>
            {ocupado === 'recusar' ? 'Recusando...' : 'Recusar'}
          </button>
          <button onClick={() => acao('aceitar')} disabled={!!ocupado}
            style={{ background: ocupado ? '#9898b8' : 'linear-gradient(135deg, #6c47ff, #5535e0)',
              color: '#fff', border: 'none', borderRadius: '10px', padding: '10px 24px',
              fontSize: '14px', fontWeight: '600', cursor: ocupado ? 'wait' : 'pointer' }}>
            {ocupado === 'aceitar' ? 'Entrando...' : 'Aceitar e entrar'}
          </button>
        </div>
      </div>
    </div>
  );
}
